@use "sass:string";

$image-max-width: 150;

.carousel {
    [data-design-version="v2024"] & {
        border-bottom: 1px solid var(--light-gray);
        padding-bottom: 24px;
    }
}

.carouselWithMask {
    composes: carousel;
    mask-image: linear-gradient(
        90deg,
        rgb(255 255 255 / 0%) 0%,
        rgb(255 255 255 / 100%) 10%,
        rgb(255 255 255 / 100%) 90%,
        rgb(255 255 255 / 0%) 100%
    );
}

.slide {
    display: inline-block;
}

.picture {
    display: inline-block;
    margin-right: var(--spacer-40);

    [data-design-version="v2026"] & {
        aspect-ratio: 1;
        overflow: hidden;
    }
}

.image {
    display: inline-block;
    max-width: #{$image-max-width}px;

    [data-design-version="v2026"] & {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

:export {
    sizes: string.unquote("#{$image-max-width}px");
}
